import { APP_SETTINGS } from "../../config";
import axios from "axios";

function fetchProjectBackLogTasks(project, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTBACKLOG.getProjectBackLogTasks,
    project,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
// function ?TaskId=1&MilesStoneId=1
// function moveToSprint(taskId, mileStoneId, projectId, token) {
//   // //  ;
//   return axios.post(
//     `${APP_SETTINGS.API_PATH.PROJECTS.PROJECTBACKLOG.moveToSprint}?TaskId=${taskId}&MilesStoneId=${mileStoneId}&projectId=${projectId}`,
//     { projectId: projectId, taskId: taskId, mileStoneId: mileStoneId },
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );
// }

function moveToSprint(data, token) {
  return axios.post(
    `${APP_SETTINGS.API_PATH.PROJECTS.PROJECTBACKLOG.moveToSprint}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

function AddProjectBackLogTasks(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTBACKLOG.addProjectBackLogTasks,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

function AddBackLogTasksInMilestone(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTBACKLOG.addBackLogTasksInMilestone,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

function DeleteProjectBackLogTasks(taskId, token) {
  var url = `${APP_SETTINGS.API_PATH.PROJECTS.PROJECTBACKLOG.deleteProjectBackLogTask}?taskId=${taskId}`;
  var resp = axios.delete(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  // console.log("resp is :", resp)
  return resp;
}

export {
  fetchProjectBackLogTasks,
  AddProjectBackLogTasks,
  AddBackLogTasksInMilestone,
  DeleteProjectBackLogTasks,
  moveToSprint,
};
